<script>
import Vue from 'vue'
import BaseResource from '../resources/index'
import UnionLocationConditionHiredResource from '../resources/unionLocationConditionHired'
import UnionLocationConditionWorkResource from '../resources/unionLocationConditionWork'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import StateResource from '../resources/state'
import OptionValueResource from '../resources/optionValue'

export default Vue.extend({
    name: 'GridMultiselect',
    props: {
        reSouces: {
            required: false,
            type: Array,
            default: () => {
                return []
            },
        },
    },
    components: {
        Multiselect,
    },

    computed: {
        gridParams() {
            // @ts-ignore
            return this.params || {}
        },
        resources() {
            return {
                StateResource,
                OptionValueResource,
                UnionLocationConditionHiredResource,
                UnionLocationConditionWorkResource,
            }
        },
    },

    data() {
        return {
            gridChanged: false,
            value: [],
            options: [],
            // to compare multi-select values
            finalRes: new Map(), // to know which values should we add
            originalRes: new Map(), // to know which values should we remove
        }
    },

    methods: {
        async getValue() {
            if (this.gridChanged) {
                for (let val of this.value) {
                    if (this.originalRes.has(val.option_id)) {
                        this.originalRes.delete(val.option_id)
                    } else {
                        this.finalRes.set(val.option_id, true)
                    }
                }
                for (let [key, value] of this.originalRes.entries()) {
                    let removeRes = this.params.values.resources.find((res) => res.attributes.id == value)
                    await removeRes.delete()
                }
                if (this.params.type == 'option_value') {
                    for (let [key, value] of this.finalRes.entries()) {
                        let newRes = new UnionLocationConditionHiredResource({
                            union_location_condition_id: this.params.data.id,
                            option_value_id: key,
                        })
                        await newRes.save()
                    }
                    let recentData = await UnionLocationConditionHiredResource.list({ query: { union_location_condition_id: this.params.data.id } })
                    let resource = recentData.resources
                    this.params.data.set('hired_from_ids', resource)
                    let manager = this.params.data.rel('hired_from_ids')
                    await manager.resolve() // resolve related - rest-resource
                } else {
                    for (let [key, value] of this.finalRes.entries()) {
                        let newRes = new UnionLocationConditionWorkResource({
                            union_location_condition_id: this.params.data.id,
                            state_id: key,
                        })
                        await newRes.save()
                    }
                    let recentData = await UnionLocationConditionWorkResource.list({ query: { union_location_condition_id: this.params.data.id } })
                    let resource = recentData.resources
                    this.params.data.set('working_in_ids', resource)
                    let manager = this.params.data.rel('working_in_ids')
                    await manager.resolve() // resolve related - rest-resource
                }
                this.gridParams.api.refreshCells({ force: true }) // redraw cell
            }
            return
        },
        select() {
            if (!this.gridChanged) this.gridChanged = true
        },
        deSelect() {
            if (!this.gridChanged) this.gridChanged = true
        },
    },
    async beforeMount() {
        // need to make normal object, not rest-resource. because It can't be used in multi-select.
        if (this.params.type == 'option_value') {
            let resource = await OptionValueResource.list({ query: { option_type_id: 15 } })
            for (let res of resource.resources) {
                let obj = {}
                obj.option_code = res.attributes.code
                obj.option_id = res.attributes.id
                this.options.push(obj)
            }
            if (this.params.values && this.params.values.resources) {
                for (let res of this.params.values.resources) {
                    let obj = {}
                    obj.option_id = res.attributes.option_value_id
                    obj.option_code = res.attributes.option_value_code
                    obj.id = res.attributes.id
                    this.value.push(obj)
                    this.originalRes.set(res.attributes.option_value_id, res.attributes.id)
                }
            }
        } else {
            let resource = await StateResource.list()
            for (let res of resource.resources) {
                let obj = {}
                obj.option_code = res.attributes.code
                obj.option_id = res.attributes.id
                this.options.push(obj)
            }
            if (this.params.values && this.params.values.resources) {
                for (let res of this.params.values.resources) {
                    let obj = {}
                    obj.option_id = res.attributes.state_id
                    obj.option_code = res.attributes.state_code
                    obj.id = res.attributes.id
                    this.value.push(obj)
                    this.originalRes.set(res.attributes.state_id, res.attributes.id)
                }
            }
        }
    },
})
</script>

<template>
    <div>
        <multiselect
            v-model="value"
            select-label=""
            deselect-label=""
            :close-on-select="false"
            placeholder=""
            label="option_code"
            track-by="option_id"
            :options="options"
            :multiple="true"
            @select="select"
            @remove="deSelect"
        ></multiselect>
    </div>
</template>

<style>
.multiselect__content-wrapper {
    position: relative;
}
</style>
